"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUpdateAccount = void 0;

var _tslib = require("tslib");

var _reactQuery = require("react-query");

var _api = require("../api");

var _types = require("../types");

var useUpdateAccount = function useUpdateAccount() {
  var queryClient = (0, _reactQuery.useQueryClient)();
  return (0, _reactQuery.useMutation)(function (account) {
    return (0, _api.updateAccount)(account);
  }, {
    onMutate: function onMutate(formValues) {
      queryClient.setQueryData(_types.QueryKeys.Account, function (account) {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, account), formValues);
      });
    }
  });
};

exports.useUpdateAccount = useUpdateAccount;